export * from './car-img-summary-5-lat.component';
